document.addEventListener('DOMContentLoaded', function () {


  //----------------Index banner slider---------------
  const slider = document.querySelector("#index-banner-splide");
  if (slider) {
    new Splide(slider, {
    //   type: 'loop',
      autoplay: false,
      interval: 7000,
      pauseOnHover: false,
      arrows: true,
      pagination: false,
    }).mount();
  }

    //Index brand marque
    const brandMarquee = document.querySelector('#brand-marquee');
    if (brandMarquee) {
        const splide = new Splide(brandMarquee, {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        arrows: false,
        gap: "50px",
        perPage: 6.5,
        breakpoints: {
            989: {
            perPage: 4,
            gap: "15px",
            },
            480: {
            perPage: 3,
            },
        },
        autoScroll: {
            speed: 1,
        },
        });
        splide.mount(window.splide.Extensions);
    }


}); // end of document

//js to open menu clild item on hover
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
// console.log(items)
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});

});
 